import { isLoaded } from "react-redux-firebase";

const whoami = state => isLoaded(state.firebase.auth) ? state.firebase.auth.uid : null;

export default whoami;



// WEBPACK FOOTER //
// ./src/selectors/whoami.js